import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BooleanToggleFilterComponent } from './components/base/boolean-toggle-filter/boolean-toggle-filter.component';
import { SpinnerComponent } from './components/base/spinner/spinner.component';
import { StatusCardComponent } from './components/base/status-card/status-card.component';
import {
  ModuleFinancialTransactionsComponent
} from './components/module-financial-transactions/module-financial-transactions.component';
import { ModuleSelectionComponent } from './components/module-selection/module-selection.component';
import {
  BankSelectionListComponent
} from './components/selection-lists/bank-selection-list/bank-selection-list.component';
import {
  CompanySelectionListComponent
} from './components/selection-lists/company-selection-list/company-selection-list.component';
import {
  ModuleSelectionListComponent
} from './components/selection-lists/module-selection-list/module-selection-list.component';
import {
  NumberOfDaysSelectionListComponent
} from './components/selection-lists/number-of-days-selection-list/number-of-days-selection-list.component';
import {
  PaymentRequestStatusSelectionListComponent
} from './components/selection-lists/payment-request-status-selection-list/payment-request-status-selection-list.component';
import {
  UserGroupSelectionListComponent
} from './components/selection-lists/user-group-selection-list/user-group-selection-list.component';
import {
  UserSelectionListComponent
} from './components/selection-lists/user-selection-list/user-selection-list.component';
import { FooterComponent } from './footer/footer.component';
import { UserProfileComponent } from './navigation-bar/navigation-bar-items/user-profile/user-profile.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar/navigation-bar.component';
import { PipesModule } from './pipes/pipes.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { CustomerOrganizationSelectionListComponent } from './components/selection-lists/customer-organization-selection-list/customer-organization-selection-list.component';
import { MinValueDirective } from './directives/min-value.directive';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    NgbModule,
    NgbModule,
    NgSelectModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    QRCodeModule,
    PipesModule,
    TranslateModule,
    NgxSpinnerModule
  ],
  exports: [
    MinValueDirective,
    CommonModule,
    FooterComponent,
    NavigationBarComponent,
    UserProfileComponent,
    SidebarComponent,
    NgbModule,
    NgSelectModule,
    FormsModule,
    StatusCardComponent,
    ModuleSelectionComponent,
    BooleanToggleFilterComponent,
    CompanySelectionListComponent,
    ModuleSelectionListComponent,
    BankSelectionListComponent,
    UserSelectionListComponent,
    QRCodeModule,
    ModuleFinancialTransactionsComponent,
    PaymentRequestStatusSelectionListComponent,
    UserGroupSelectionListComponent,
    TranslateModule,
    SpinnerComponent,
    NumberOfDaysSelectionListComponent,
    CustomerOrganizationSelectionListComponent
  ],
  declarations: [
    MinValueDirective,
    FooterComponent,
    NavigationBarComponent,
    UserProfileComponent,
    SidebarComponent,
    StatusCardComponent,
    ModuleSelectionComponent,
    BooleanToggleFilterComponent,
    CompanySelectionListComponent,
    ModuleSelectionListComponent,
    BankSelectionListComponent,
    UserSelectionListComponent,
    ModuleFinancialTransactionsComponent,
    PaymentRequestStatusSelectionListComponent,
    UserGroupSelectionListComponent,
    SpinnerComponent,
    NumberOfDaysSelectionListComponent,
    CustomerOrganizationSelectionListComponent
  ],
  entryComponents: [
    StatusCardComponent,
    BooleanToggleFilterComponent,
    CompanySelectionListComponent,
    ModuleSelectionListComponent,
    BankSelectionListComponent,
    UserSelectionListComponent,
    PaymentRequestStatusSelectionListComponent,
    UserGroupSelectionListComponent,
    SpinnerComponent,
    NumberOfDaysSelectionListComponent,
    CustomerOrganizationSelectionListComponent
  ]
})
export class SharedModule {
}
